/* ============================================
   Wholistic House — Product Catalog
   All products with health category mappings
   ============================================ */

var PRODUCTS = {
  // ==========================================
  // LIPOSOMAL MUSHROOM BLENDS (Flagship)
  // ==========================================

  'i-am-complete': {
    name: 'I am Complete',
    subtitle: 'The Mushroom Alchemy of Wholeness — eight ancient medicinal mushrooms',
    price: '$170.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_70_grande.png',
    shopUrl: 'https://wholistichouse.co/products/i-am-complete',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['energy', 'stress'],
    secondaryCategories: [],
    categoryScores: { energy: 4, stress: 2, skin: 1 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, nutrient_depletion: 3, aging_skin: 1 },
    whyText: 'A naturopath would recommend I am Complete as a broad replenishing formula when someone needs a premium all-in-one nutritional rebuild.',
    differentiator: 'It is more comprehensive and foundational than a single-nutrient product and acts like a premium nourishment base.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['super-d3-k2', 'lipo-d3-k2'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'blood_thinners', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 6,
    maxBundleCount: 1
  },

  'immune-warrior': {
    name: 'Immune Warrior',
    subtitle: 'Defend. Fortify. Thrive — five ancient immune-boosting mushrooms',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_72_grande.png',
    shopUrl: 'https://wholistichouse.co/products/immune-warrior',
    badge: 'Pre-Order',
    format: 'liposomal',
    primaryCategories: ['energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 4, stress: 1, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, nutrient_depletion: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Immune Warrior when someone needs stronger everyday immune resilience and recovery support.',
    differentiator: 'It is more immune-directed than the broad nutrition products and more everyday-friendly than a full protocol bundle.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: [],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'quantum-c': {
    name: 'Quantum–C',
    subtitle: 'Liposomal Antioxidant & Immune Booster',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_65_grande.png',
    shopUrl: 'https://wholistichouse.co/products/qantum-c',
    badge: 'Liposomal',
    format: 'liposomal',
    primaryCategories: ['energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 5, skin: 1, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, low_motivation: 1, aging_skin: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Quantum–C as a broad-spectrum, food-based antioxidant and nutrition support formula for depleted, inflamed, run-down customers.',
    differentiator: 'It is more comprehensive and restorative than a single antioxidant, making it a higher-level \'foundational plus\' product.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: [],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'blood_thinners', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'endless-energy': {
    name: 'Endless Energy',
    subtitle: 'Adrenals & Vitality — sustained energy and adrenal balance',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_69_grande.png',
    shopUrl: 'https://wholistichouse.co/products/endless-energy',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['energy'],
    secondaryCategories: [],
    categoryScores: { energy: 6, sleep: 1, stress: 1 },
    symptomScores: { constant_fatigue: 3, afternoon_crash: 3, low_motivation: 3, unrefreshed: 1, overwhelm: 1, nutrient_depletion: 1 },
    whyText: 'A naturopath would recommend Endless Energy when low adrenal resilience, fatigue, and daily \'flatness\' are bigger issues than pure sleep or hormone symptoms.',
    differentiator: 'It is the most vitality-and-adrenal oriented tonic in the range, more energising than broad nutritional support.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['burn-it-baby'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'blood_pressure'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily, preferably earlier in the day.',
    resultsTimeline: '1-2 weeks',
    priority: 8,
    maxBundleCount: 1
  },

  'tummy-love': {
    name: 'Tummy Love',
    subtitle: 'A Gentle Hug for Your Gut — comprehensive digestive harmony',
    price: '$90.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_77_grande.png',
    shopUrl: 'https://wholistichouse.co/products/tummy-love',
    badge: 'New Improved Formula',
    format: 'liposomal',
    primaryCategories: ['gut'],
    secondaryCategories: [],
    categoryScores: { gut: 5 },
    symptomScores: { bloating: 3, constipation: 3, cramps: 1, food_sensitivities: 3 },
    whyText: 'A naturopath would recommend Tummy Love for prebiotic digestive nourishment and gentle support to better gut balance over time.',
    differentiator: 'It is more microbiome-feeding and gentle than Bloat Free or Colonic in a Bottle, which are more symptom- or bowel-directed.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['colonic-in-a-bottle', 'para-broom'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'silent-night': {
    name: 'Silent Night',
    subtitle: 'Rest Deeply. Wake Renewed — natural sleep support',
    price: '$90.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_60_grande.png',
    shopUrl: 'https://wholistichouse.co/products/silent-night',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['sleep'],
    secondaryCategories: [],
    categoryScores: { sleep: 7 },
    symptomScores: { falling_asleep: 3, waking: 3, unrefreshed: 3, restless: 1, racing_mind: 1 },
    whyText: 'A naturopath would recommend Silent Night when the customer wants a more direct sleep formula for sleep onset, staying asleep, and next-day recovery.',
    differentiator: 'It is a more overt sleep formula than Relax and Breathe, which is better for daytime calm.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: [],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'ssri'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 1 to 2 teaspoons before bed.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'relax-and-breathe': {
    name: 'Relax & Breathe',
    subtitle: 'Restore Calm. Reclaim Stillness — soothing stress elixir',
    price: '$90.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_73_grande.png',
    shopUrl: 'https://wholistichouse.co/products/relax-and-breathe',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['stress'],
    secondaryCategories: [],
    categoryScores: { sleep: 1, stress: 7 },
    symptomScores: { racing_mind: 1, anxiety: 3, racing_thoughts: 3, muscle_tension: 1, overwhelm: 3 },
    whyText: 'A naturopath would recommend Relax and Breathe for daytime calm, nervous-system settling, and stress resilience without making sleep the only focus.',
    differentiator: 'It is the main daytime calming formula, whereas Silent Night and Sleep Sprinkles are more bedtime-focused.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['sleep-sprinkles'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_pressure', 'ssri'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 capsules daily, or use later in the day if stress is evening-weighted.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'switched-on': {
    name: 'Switched On',
    subtitle: 'Ignite Focus. Elevate Clarity — cognitive support',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_76_grande.png',
    shopUrl: 'https://wholistichouse.co/products/switched-on',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['energy'],
    secondaryCategories: [],
    categoryScores: { energy: 7 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, afternoon_crash: 1, low_motivation: 3 },
    whyText: 'A naturopath would recommend Switched On when the dominant complaint is cognitive fatigue, poor focus, and mental underperformance.',
    differentiator: 'It is the clearest cognition-and-focus formula in the range rather than a general energy or longevity tonic.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['super-pqq', 'endless-energy'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'blood_pressure', 'ssri'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 capsules daily, ideally earlier in the day.',
    resultsTimeline: 'days',
    priority: 7,
    maxBundleCount: 1
  },

  'i-am-woman': {
    name: 'I am Woman',
    subtitle: 'Harmony. Strength. Radiance — hormonal balance for women',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_71_grande.png',
    shopUrl: 'https://wholistichouse.co/products/i-am-woman',
    badge: 'New Formula',
    format: 'liposomal',
    primaryCategories: ['hormones'],
    secondaryCategories: [],
    categoryScores: { sleep: 1, hormones: 7 },
    symptomScores: { unrefreshed: 1, pms: 3, irregular_cycle: 3, perimenopause: 3, low_libido: 1 },
    whyText: 'A naturopath would recommend I am Woman as a broad female hormone tonic for women needing whole-picture endocrine support rather than one narrow hormone angle.',
    differentiator: 'It is a broader women\'s tonic than Estro Sweep or Evolve, which are more specific to estrogen clearance or perimenopause.',
    gender: 'women',
    lifeStages: ['perimenopause'],
    conflicts: ['evolve'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'birth_control'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 8,
    maxBundleCount: 1
  },

  'burn-it-baby': {
    name: 'Burn It Baby',
    subtitle: 'Set Your Metabolic Fire Ablaze — metabolic support blend',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/WH_FB_AD_80_grande.png',
    shopUrl: 'https://wholistichouse.co/products/burn-it-baby',
    badge: 'New Improved Formula',
    format: 'liposomal',
    primaryCategories: ['energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 5, inflammation: 3 },
    symptomScores: { constant_fatigue: 1, afternoon_crash: 3, low_motivation: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Burn It Baby when the priority is metabolic drive, thermogenic support, and helping stubborn fat-loss clients feel more switched on.',
    differentiator: 'It is more active and weight-loss oriented than berberine or fibre, which are gentler metabolic-support products.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['endless-energy'],
    exclusions: ['pregnant_breastfeeding'],
    softExclusions: ['thyroid', 'diabetes', 'blood_pressure', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true, active: true },
    usageGuidance: 'Take 2 teaspoons before meals.',
    resultsTimeline: 'days',
    priority: 5,
    maxBundleCount: 1
  },

  'ageless-beauty': {
    name: 'Ageless Beauty',
    subtitle: 'Awaken Your Radiance from Within — mushrooms and superfoods for skin',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_66_grande.png',
    shopUrl: 'https://wholistichouse.co/products/ageless-beauty',
    badge: 'New Improved Formula',
    format: 'liposomal',
    primaryCategories: ['skin', 'hair'],
    secondaryCategories: [],
    categoryScores: { skin: 7, hair: 5, inflammation: 1 },
    symptomScores: { aging_skin: 3, hair_thinning: 3, brittle_nails: 3, chronic_inflammation: 1 },
    whyText: 'A naturopath would recommend Ageless Beauty to nourish skin, hair, nails, and graceful aging from a mineral- and antioxidant-support perspective.',
    differentiator: 'It is the beauty-and-longevity tonic in the range rather than a direct hormone, collagen, or hair-pigment product.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['inner-glow-protocol', 'grey-away'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 teaspoons daily.',
    resultsTimeline: '4-6 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'evolve': {
    name: 'Evolve',
    subtitle: 'Balance. Strength. Renewal — perimenopause support',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/WH_FB_AD_84_grande.png',
    shopUrl: 'https://wholistichouse.co/products/evolve',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['hormones', 'sleep'],
    secondaryCategories: [],
    categoryScores: { sleep: 3, stress: 1, hormones: 4 },
    symptomScores: { waking: 3, unrefreshed: 1, anxiety: 1, perimenopause: 3, low_libido: 3 },
    whyText: 'A naturopath would recommend Evolve for women entering perimenopause who need support with the transition itself rather than generic female hormones alone.',
    differentiator: 'It is the most clearly perimenopause-introductory product in the range, more phase-specific than I am Woman.',
    gender: 'women',
    lifeStages: ['perimenopause'],
    conflicts: ['i-am-woman'],
    exclusions: ['pregnant_breastfeeding'],
    softExclusions: ['thyroid', 'birth_control'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'para-broom': {
    name: 'Para Broom',
    subtitle: 'Daily ritual for digestive balance and inner harmony — detox & parasite cleanse',
    price: '$180.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_59_grande.png',
    shopUrl: 'https://wholistichouse.co/products/para-broom',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['gut'],
    secondaryCategories: [],
    categoryScores: { gut: 5 },
    symptomScores: { bloating: 3, loose_stools: 1, cramps: 3, food_sensitivities: 1, parasites: 3 },
    whyText: 'A naturopath would recommend Para Broom as a more purposeful anti-parasitic and gut-cleansing formula when symptoms point to dysbiosis or unwanted bugs.',
    differentiator: 'It is the most anti-parasite/anti-microbial product in the range and is not the same as a daily digestive support product.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['colonic-in-a-bottle', 'tummy-love'],
    exclusions: ['pregnant_breastfeeding'],
    softExclusions: ['blood_thinners'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take as directed on label, usually with food unless otherwise stated.',
    resultsTimeline: 'days',
    priority: 4,
    maxBundleCount: 1
  },

  'clean-and-pure': {
    name: 'Clean and Pure',
    subtitle: 'Detox, Renew, Radiate — internal reset formula',
    price: '$90.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_67_grande.png',
    shopUrl: 'https://wholistichouse.co/products/clean-and-pure',
    badge: null,
    format: 'liposomal',
    primaryCategories: ['skin'],
    secondaryCategories: ['inflammation'],
    categoryScores: { energy: 1, skin: 7, inflammation: 3 },
    symptomScores: { bloating: 1, brain_fog: 1, aging_skin: 3, breakouts: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Clean and Pure for customers needing a deeper beauty-detox-liver reset with a focus on skin clarity and feeling cleaner internally.',
    differentiator: 'It combines detox and radiance more than Liver Love, which is the more classic liver formula.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['nac-600', 'immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'blood_thinners', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 teaspoons daily.',
    resultsTimeline: 'days',
    priority: 6,
    maxBundleCount: 1
  },

  // ==========================================
  // CAPSULES
  // ==========================================

  'estro-sweep': {
    name: 'Estro Sweep',
    subtitle: 'Natural Liver Support for Hormonal Balance',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_25_grande.png',
    shopUrl: 'https://wholistichouse.co/products/estro-sweep',
    badge: null,
    format: 'capsule',
    primaryCategories: ['hormones'],
    secondaryCategories: [],
    categoryScores: { hormones: 7 },
    symptomScores: { bloating: 1, pms: 3, irregular_cycle: 3, perimenopause: 1, acne: 3, low_libido: 1 },
    whyText: 'A naturopath would recommend Estro Sweep to support healthy estrogen clearance in women with PMS, estrogen-dominant symptoms, and hormonal skin flare-ups.',
    differentiator: 'It is the most estrogen-clearance-focused product in the range rather than a broad female hormone tonic.',
    gender: 'women',
    lifeStages: ['perimenopause'],
    conflicts: ['evolve'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'birth_control'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 8,
    maxBundleCount: 1
  },

  'bloat-free': {
    name: 'Bloat Free',
    subtitle: 'Gas Relief Capsules — plant-based digestive comfort',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_20_grande.png',
    shopUrl: 'https://wholistichouse.co/products/bloat-free',
    badge: 'Pre-Order',
    format: 'capsule',
    primaryCategories: ['gut'],
    secondaryCategories: [],
    categoryScores: { gut: 5 },
    symptomScores: { bloating: 3, reflux: 1, loose_stools: 1, cramps: 3, food_sensitivities: 3 },
    whyText: 'A naturopath would recommend Bloat Free as a targeted digestive-comfort formula when gas, pressure, and post-meal bloating are the main complaint.',
    differentiator: 'It is a faster symptom-relief style product than deeper gut-repair formulas like Tummy Tonic.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['colonic-in-a-bottle'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules before meals or as directed on label.',
    resultsTimeline: 'days',
    priority: 9,
    maxBundleCount: 1
  },

  'colonic-in-a-bottle': {
    name: 'Colonic in a Bottle',
    subtitle: 'The Cleanse You Actually Want to Do — gentle digestive reset',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_23_grande.png',
    shopUrl: 'https://wholistichouse.co/products/colonic-in-a-bottle',
    badge: null,
    format: 'capsule',
    primaryCategories: ['gut'],
    secondaryCategories: [],
    categoryScores: { gut: 5 },
    symptomScores: { bloating: 3, constipation: 3, cramps: 3, food_sensitivities: 1 },
    whyText: 'A naturopath would recommend Colonic in a Bottle as a short-term bowel-support product when sluggish elimination is a major contributor to symptoms.',
    differentiator: 'It is more bowel-motility and constipation directed than the gentler daily gut products.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['tummy-love'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take as directed on label, ideally with plenty of water.',
    resultsTimeline: 'days',
    priority: 6,
    maxBundleCount: 1
  },

  'tummy-tonic': {
    name: 'Tummy Tonic',
    subtitle: 'Digestive Capsules for Gut Health — plant-based comfort and intestinal repair',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_36_grande.png',
    shopUrl: 'https://wholistichouse.co/products/tummy-tonic',
    badge: '6x Sold Out',
    format: 'capsule',
    primaryCategories: ['gut'],
    secondaryCategories: ['inflammation'],
    categoryScores: { gut: 6, energy: 1, stress: 1, skin: 1, inflammation: 2 },
    symptomScores: { bloating: 3, reflux: 1, loose_stools: 3, cramps: 3, food_sensitivities: 3, brain_fog: 1, afternoon_crash: 1, anxiety: 1, breakouts: 1, joint_pain: 1, chronic_inflammation: 1 },
    whyText: 'A naturopath would recommend Tummy Tonic as a gentle daily gut-repair formula to calm irritation, support the intestinal lining, and reduce everyday digestive reactivity.',
    differentiator: 'It is the broadest all-round gut-repair capsule in the range, sitting between simple microbiome support and stronger short-term bowel or parasite protocols.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: [],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily; best used consistently for several weeks.',
    resultsTimeline: 'days',
    priority: 10,
    maxBundleCount: 1
  },

  'liver-love': {
    name: 'Liver Love',
    subtitle: 'Organic Detox & Cleanse Capsules — clinical-grade liver detoxification',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_28_grande.png',
    shopUrl: 'https://wholistichouse.co/products/liver-love',
    badge: null,
    format: 'capsule',
    primaryCategories: ['hormones', 'skin', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { hormones: 3, skin: 3, inflammation: 3 },
    symptomScores: { bloating: 1, pms: 1, acne: 3, aging_skin: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Liver Love to support detoxification, hormone clearance, and sluggish, overloaded liver patterns.',
    differentiator: 'It is more classically liver-directed than Clean and Pure, which has a broader skin-detox-beauty angle.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners', 'birth_control'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'angio-block': {
    name: 'Angio Block',
    subtitle: 'Nature\'s Powerful Antioxidant Defense',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_19_grande.png',
    shopUrl: 'https://wholistichouse.co/products/angio-block',
    badge: 'Pre-Order',
    format: 'capsule',
    primaryCategories: ['energy', 'skin', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 3, skin: 3, inflammation: 3 },
    symptomScores: { constant_fatigue: 1, brain_fog: 3, aging_skin: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Angio Block when a customer needs high-level antioxidant and vascular support rather than a basic wellness formula.',
    differentiator: 'It is more specialised and \'higher-order\' than general antioxidant products, leaning into vascular, cellular, and longevity-oriented support.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: [],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules with food daily.',
    resultsTimeline: '4-6 weeks',
    priority: 3,
    maxBundleCount: 1
  },

  'berberine': {
    name: 'Berberine',
    subtitle: 'Ancient Wisdom, Modern Metabolic Support',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_24_grande.png',
    shopUrl: 'https://wholistichouse.co/products/berberine-500mg',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 5, hormones: 1, inflammation: 3 },
    symptomScores: { constant_fatigue: 1, afternoon_crash: 3, low_motivation: 3, pms: 1, acne: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend berberine to support blood-sugar regulation, metabolic health, and appetite control in customers whose symptoms worsen around meals and energy dips.',
    differentiator: 'It is the most direct metabolic capsule in the range and is better for glucose and appetite regulation than fibre-only or general energy products.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['burn-it-baby'],
    exclusions: [],
    softExclusions: ['diabetes', 'pregnant_breastfeeding', 'blood_pressure'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 1 capsule before meals.',
    resultsTimeline: 'days',
    priority: 7,
    maxBundleCount: 1
  },

  'breast-nurture': {
    name: 'Breast Nurture',
    subtitle: 'A Woman\'s Daily Ritual of Care & Balance',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_21_grande.png',
    shopUrl: 'https://wholistichouse.co/products/breast-nurture',
    badge: null,
    format: 'capsule',
    primaryCategories: ['hormones'],
    secondaryCategories: [],
    categoryScores: { hormones: 7 },
    symptomScores: { bloating: 1, pms: 3, irregular_cycle: 3, perimenopause: 1, acne: 3 },
    whyText: 'A naturopath would recommend Breast Nurture when female hormonal symptoms cluster around breast tenderness, PMS, and cyclic estrogen load.',
    differentiator: 'It is more breast-and-female-hormone focused than Estro Sweep, which is more directly about estrogen clearance.',
    gender: 'women',
    lifeStages: ['perimenopause'],
    conflicts: ['evolve'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'birth_control'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '4-6 weeks',
    priority: 6,
    maxBundleCount: 1
  },

  'grey-away': {
    name: 'Grey Away',
    subtitle: 'Turn Back the Strands of Time — hair pigmentation support',
    price: '$70.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_42_grande.png',
    shopUrl: 'https://wholistichouse.co/products/grey-away',
    badge: 'Pre-Order',
    format: 'capsule',
    primaryCategories: ['hair'],
    secondaryCategories: ['skin'],
    categoryScores: { skin: 4, hair: 10 },
    symptomScores: { aging_skin: 3, hair_thinning: 3, hair_greying: 3, brittle_nails: 1 },
    whyText: 'A naturopath would recommend Grey Away for customers wanting to support hair pigment and the nutritional terrain around premature greying.',
    differentiator: 'It is more specifically pigment-focused than Hair Juice, which leans more to growth and strength.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['inner-glow-protocol'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily.',
    resultsTimeline: '8+ weeks',
    priority: 4,
    maxBundleCount: 1
  },

  'hair-juice': {
    name: 'Hair Juice',
    subtitle: 'Hair Growth in a Bottle — nourish your crown',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_41_grande.png',
    shopUrl: 'https://wholistichouse.co/products/hair-juice',
    badge: null,
    format: 'capsule',
    primaryCategories: ['skin', 'hair'],
    secondaryCategories: [],
    categoryScores: { skin: 7, hair: 7 },
    symptomScores: { aging_skin: 3, hair_thinning: 3, hair_greying: 1, brittle_nails: 3 },
    whyText: 'A naturopath would recommend Hair Juice to nourish hair growth, strengthen weak strands, and improve the nutritional terrain behind thinning hair.',
    differentiator: 'It is more growth-and-strength focused than Grey Away, which is more specifically about pigment support.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['inner-glow-protocol'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '4-6 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'iron-infusion': {
    name: 'Iron Infusion',
    subtitle: 'Plant-based iron support for energy production',
    price: '$90.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_61_grande.png',
    shopUrl: 'https://wholistichouse.co/products/iron-infusion',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy'],
    secondaryCategories: ['sleep'],
    categoryScores: { energy: 5, sleep: 2 },
    symptomScores: { constant_fatigue: 3, low_motivation: 1, iron_symptoms: 3, unrefreshed: 3 },
    whyText: 'A naturopath would recommend Iron Infusion when symptoms suggest low iron stores and the customer needs a gentler, more bioavailable iron option.',
    differentiator: 'It is the clearest deficiency-correction product in the range and should be used more deliberately than general energy formulas.',
    gender: 'anyone',
    lifeStages: ['postpartum'],
    conflicts: ['metaburn-fibre', 'iodine'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take daily as directed on label, ideally away from tea, coffee, fibre, and thyroid medication.',
    resultsTimeline: '1-2 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'mag-power': {
    name: 'Mag Power',
    subtitle: 'Magnesium Glycinate 400mg — the master mineral of calm',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_30_grande.png',
    shopUrl: 'https://wholistichouse.co/products/mag-power',
    badge: null,
    format: 'capsule',
    primaryCategories: ['sleep', 'stress'],
    secondaryCategories: [],
    categoryScores: { sleep: 5, stress: 3 },
    symptomScores: { constipation: 1, waking: 3, unrefreshed: 1, restless: 3, anxiety: 1, muscle_tension: 3 },
    whyText: 'A naturopath would recommend Mag Power for stress-driven tension, sleep support, and magnesium replenishment in depleted customers.',
    differentiator: 'It is the broader powdered magnesium option for muscular relaxation and replenishment, distinct from the liposomal liquid format.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['lipo-magnesium', 'sleep-sprinkles'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_pressure'],
    lifestyleBoosts: { caffeine: true },
    usageGuidance: 'Take 1 to 2 teaspoons daily, ideally in the evening.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'meriva-curcumin': {
    name: 'Meriva Curcumin 500',
    subtitle: 'Enhanced Absorption Curcumin Support',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_10_grande.png',
    shopUrl: 'https://wholistichouse.co/products/meriva-curcumin-500',
    badge: null,
    format: 'capsule',
    primaryCategories: ['inflammation'],
    secondaryCategories: [],
    categoryScores: { inflammation: 10 },
    symptomScores: { joint_pain: 3, chronic_inflammation: 3, post_exercise_recovery: 3 },
    whyText: 'A naturopath would recommend Meriva Curcumin for targeted capsule-based inflammation support where joints, pain, or recovery are central.',
    differentiator: 'It is the capsule curcumin option, while Lipo Turmeric is the liquid anti-inflammatory alternative.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: ['lipo-turmeric', 'lipo-pea'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true, active: true },
    usageGuidance: 'Take 1 capsule daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'mojo-rising': {
    name: 'Mojo Rising',
    subtitle: 'Vitality. Drive. Strength — male vitality blend',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_39_grande.png',
    shopUrl: 'https://wholistichouse.co/products/mojo-rising',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy', 'hormones'],
    secondaryCategories: [],
    categoryScores: { energy: 4, sleep: 1, hormones: 2 },
    symptomScores: { constant_fatigue: 3, low_motivation: 3, unrefreshed: 1, low_libido: 3 },
    whyText: 'A naturopath would recommend Mojo Rising for men wanting support for vitality, libido, and confidence-driving energy.',
    differentiator: 'It is the clearest male vitality formula in the range rather than a general energy tonic.',
    gender: 'men',
    lifeStages: ['aging'],
    conflicts: ['burn-it-baby', 'i-am-woman'],
    exclusions: ['pregnant_breastfeeding'],
    softExclusions: ['thyroid', 'blood_pressure'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 6,
    maxBundleCount: 1
  },

  'nac-600': {
    name: 'NAC 600',
    subtitle: 'Cellular Defense, Detox & Respiratory Support',
    price: '$56.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_40_grande.png',
    shopUrl: 'https://wholistichouse.co/products/nac-600',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 4, skin: 1, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, breakouts: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend NAC 600 for antioxidant, detox, respiratory, and glutathione-support pathways where a sharper, more clinical product is needed.',
    differentiator: 'It is more direct and single-ingredient-driven than broader detox formulas like Liver Love or Clean and Pure.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['clean-and-pure', 'immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { caffeine: true },
    usageGuidance: 'Take 1 capsule daily with food unless otherwise directed.',
    resultsTimeline: '1-2 weeks',
    priority: 4,
    maxBundleCount: 1
  },

  'ocean-omegas': {
    name: 'Ocean Omegas',
    subtitle: 'Pure. Potent. Pristine — premium fish oil formula',
    price: '$76.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/WH_FB_AD_78_grande.png',
    shopUrl: 'https://wholistichouse.co/products/ocean-omegas',
    badge: 'Back in stock',
    format: 'capsule',
    primaryCategories: ['inflammation'],
    secondaryCategories: ['skin'],
    categoryScores: { energy: 1, hormones: 1, skin: 3, inflammation: 8 },
    symptomScores: { brain_fog: 1, acne: 1, aging_skin: 3, joint_pain: 3, chronic_inflammation: 3, post_exercise_recovery: 1 },
    whyText: 'A naturopath would recommend Ocean Omegas for anti-inflammatory support, brain and heart nourishment, and skin and joint resilience.',
    differentiator: 'It is the main essential-fatty-acid product in the range and complements many formulas without duplicating them.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: ['immune-defense-protocol', 'inner-glow-protocol'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 2 capsules daily.',
    resultsTimeline: '4-6 weeks',
    priority: 7,
    maxBundleCount: 1
  },

  'primal-restore': {
    name: 'Primal Restore',
    subtitle: 'Grass-fed beef liver and spleen supplement',
    price: '$55.00 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/WH_FB_AD_90_grande.png',
    shopUrl: 'https://wholistichouse.co/products/primal-restore',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy'],
    secondaryCategories: ['hair'],
    categoryScores: { energy: 6, hair: 2 },
    symptomScores: { constant_fatigue: 3, low_motivation: 3, iron_symptoms: 3, hair_thinning: 1 },
    whyText: 'A naturopath would recommend Primal Restore to rebuild from the ground up when vitality, iron-rich nourishment, and resilience need support.',
    differentiator: 'It is the most ancestral animal-organ style product in the range rather than a plant-based tonic or simple iron liquid.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: ['i-am-complete'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 2 capsules daily.',
    resultsTimeline: '1-2 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'pure-resveratrol': {
    name: 'Pure Resveratrol',
    subtitle: 'Antioxidant Power for Timeless Vitality',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_32_grande.png',
    shopUrl: 'https://wholistichouse.co/products/pure-resveratrol',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy', 'skin', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 3, skin: 3, inflammation: 3 },
    symptomScores: { constant_fatigue: 1, brain_fog: 3, aging_skin: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Pure Resveratrol for longevity-minded antioxidant and healthy aging support.',
    differentiator: 'It is a cleaner longevity-focused antioxidant compared with broader whole-food or immune products.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 1 capsule daily with food.',
    resultsTimeline: '4-6 weeks',
    priority: 3,
    maxBundleCount: 1
  },

  'pyrrole-perfect': {
    name: 'Pyrrole Perfect',
    subtitle: 'Outsmart Stress, Keep Your Nutrients Where They Belong',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_46_grande.png',
    shopUrl: 'https://wholistichouse.co/products/pyrrole-perfect',
    badge: null,
    format: 'capsule',
    primaryCategories: ['stress'],
    secondaryCategories: [],
    categoryScores: { energy: 1, sleep: 1, stress: 6 },
    symptomScores: { brain_fog: 1, low_motivation: 1, racing_mind: 1, anxiety: 3, racing_thoughts: 3, nutrient_depletion: 3 },
    whyText: 'A naturopath would recommend Pyrrole Perfect where stress, inner tension, and nutrient depletion patterns suggest a pyroluria-style picture.',
    differentiator: 'It is more targeted to stress chemistry and nutrient depletion than general calming or sleep formulas.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['i-am-complete', 'super-pqq'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'ssri'],
    lifestyleBoosts: { caffeine: true },
    usageGuidance: 'Take 2 capsules daily with food.',
    resultsTimeline: '1-2 weeks',
    priority: 4,
    maxBundleCount: 1
  },

  'sb-500': {
    name: 'SB 500',
    subtitle: 'High-Potency Gut & Immune Support',
    price: '$61.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_17_grande.png',
    shopUrl: 'https://wholistichouse.co/products/sb500',
    badge: null,
    format: 'capsule',
    primaryCategories: ['gut'],
    secondaryCategories: [],
    categoryScores: { gut: 5 },
    symptomScores: { bloating: 3, loose_stools: 3, cramps: 1, food_sensitivities: 1, parasites: 3 },
    whyText: 'A naturopath would recommend SB 500 when digestive symptoms suggest yeast, loose stools, travel gut issues, or the need for more resilient microbiome support.',
    differentiator: 'It is the main Saccharomyces boulardii-style probiotic in the range, distinct from prebiotic or gut-repair formulas.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take daily as directed on label.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'sleep-sprinkles': {
    name: 'Sleep Sprinkles',
    subtitle: 'A Lullaby in Every Dose — botanical sleep blend',
    price: '$51.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_35_grande.png',
    shopUrl: 'https://wholistichouse.co/products/sleep-sprinkles',
    badge: null,
    format: 'capsule',
    primaryCategories: ['sleep'],
    secondaryCategories: [],
    categoryScores: { sleep: 7 },
    symptomScores: { falling_asleep: 3, waking: 3, unrefreshed: 1, restless: 1, racing_mind: 3 },
    whyText: 'A naturopath would recommend Sleep Sprinkles for gentle nightly support when settling, switching off, and sleeping deeply are the main goals.',
    differentiator: 'It is a softer evening sleep format than some capsule-based options and suits customers who like a bedtime ritual.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: [],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'ssri'],
    lifestyleBoosts: { caffeine: true },
    usageGuidance: 'Take 1 to 2 teaspoons before bed.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'super-d3-k2': {
    name: 'Super D3/K2',
    subtitle: 'Sunshine in Every Drop — vitamin D and K2',
    price: '$56.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_22_grande.png',
    shopUrl: 'https://wholistichouse.co/products/super-potent-d3-k2',
    badge: null,
    format: 'capsule',
    primaryCategories: ['inflammation'],
    secondaryCategories: ['sleep'],
    categoryScores: { energy: 1, sleep: 2, inflammation: 7 },
    symptomScores: { constant_fatigue: 1, unrefreshed: 3, joint_pain: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Super D3/K2 for foundational bone, immune, and inflammatory support when vitamin D status or resilience looks low.',
    differentiator: 'It gives targeted vitamin D/K support in capsule format, whereas the liposomal version is better for customers who prefer liquid absorption.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['lipo-d3-k2', 'i-am-complete'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 1 capsule daily with food.',
    resultsTimeline: '4-6 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'super-pqq': {
    name: 'Super PQQ',
    subtitle: 'Cellular Energy, Cognitive Vitality & Mitochondrial Support',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/WH_FB_AD_73_grande.png',
    shopUrl: 'https://wholistichouse.co/products/super-pqq',
    badge: null,
    format: 'capsule',
    primaryCategories: ['energy'],
    secondaryCategories: [],
    categoryScores: { energy: 7 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, afternoon_crash: 1, low_motivation: 3 },
    whyText: 'A naturopath would recommend Super PQQ for mitochondrial energy, mental sharpness, and healthy aging support in customers who feel flat at a cellular level.',
    differentiator: 'It is more mitochondrial and longevity-oriented than Switched On or Endless Energy, which are more symptom-direct for focus or adrenals.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['switched-on', 'endless-energy'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 1 capsule with food.',
    resultsTimeline: '1-2 weeks',
    priority: 4,
    maxBundleCount: 1
  },

  // ==========================================
  // LIPOSOMAL LIQUIDS
  // ==========================================

  'lipo-d3-k2': {
    name: 'Liposomal D3/K2',
    subtitle: 'Advanced liposomal vitamin D and K2 formula',
    price: '$51.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_55_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-d3-k2',
    badge: null,
    format: 'liquid',
    primaryCategories: ['inflammation'],
    secondaryCategories: ['sleep'],
    categoryScores: { energy: 1, sleep: 2, inflammation: 7 },
    symptomScores: { constant_fatigue: 1, unrefreshed: 3, joint_pain: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Lipo D3/K2 for foundational vitamin D and K support when absorption, bones, immune resilience, or inflammation are concerns.',
    differentiator: 'It offers the same general goal as Super D3/K2 but in a liquid liposomal format for customers who prefer liquid delivery.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['super-d3-k2', 'i-am-complete'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 1 teaspoon daily.',
    resultsTimeline: '4-6 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'lipo-glutathione': {
    name: 'Liposomal Glutathione',
    subtitle: 'The Master Antioxidant of Cellular Defense',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_52_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-glutathione',
    badge: null,
    format: 'liquid',
    primaryCategories: ['skin', 'energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 3, skin: 4, inflammation: 3 },
    symptomScores: { constant_fatigue: 1, brain_fog: 3, aging_skin: 3, breakouts: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend liposomal glutathione for detox, antioxidant defence, skin brightness, and recovery from oxidative stress.',
    differentiator: 'It is the most direct glutathione/detox product in the range, distinct from broader liver or anti-inflammatory formulas.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['immune-defense-protocol'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true, caffeine: true },
    usageGuidance: 'Take 1 to 2 teaspoons daily.',
    resultsTimeline: '1-2 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'lipo-magnesium': {
    name: 'Liposomal Magnesium',
    subtitle: 'The Master Mineral of Calm, Energy & Vitality',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_51_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-magnesium',
    badge: null,
    format: 'liquid',
    primaryCategories: ['sleep', 'stress'],
    secondaryCategories: [],
    categoryScores: { sleep: 4, stress: 4 },
    symptomScores: { falling_asleep: 3, waking: 1, restless: 1, racing_mind: 1, anxiety: 3, muscle_tension: 3 },
    whyText: 'A naturopath would recommend liposomal magnesium when calm, sleep, and nervous-system downshifting are the main goals and liquid delivery is preferred.',
    differentiator: 'It is the most sleep-and-nervous-system-directed magnesium in the range, whereas Mag Power is more broad and powder-based.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['sleep-sprinkles'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_pressure'],
    lifestyleBoosts: { caffeine: true },
    usageGuidance: 'Take 2 teaspoons daily.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'lipo-pea': {
    name: 'Liposomal P.E.A',
    subtitle: 'Calm the Flames. Restore the Balance — inflammation support',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_56_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-p-e-a',
    badge: null,
    format: 'liquid',
    primaryCategories: ['inflammation'],
    secondaryCategories: ['stress'],
    categoryScores: { stress: 2, inflammation: 8 },
    symptomScores: { muscle_tension: 3, joint_pain: 3, chronic_inflammation: 3, post_exercise_recovery: 1 },
    whyText: 'A naturopath would recommend liposomal P.E.A when pain, inflammation, and hypersensitivity are the main complaints.',
    differentiator: 'It is more pain- and discomfort-directed than turmeric or omega products, though all sit in the inflammation space.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['meriva-curcumin', 'lipo-turmeric'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 1 teaspoon twice daily.',
    resultsTimeline: '1-2 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'lipo-quercetin-zinc': {
    name: 'Liposomal Quercetin/Zinc',
    subtitle: 'Cellular Defense in Perfect Harmony',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_50_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-quercetin-zinc',
    badge: null,
    format: 'liquid',
    primaryCategories: ['skin', 'inflammation', 'gut'],
    secondaryCategories: [],
    categoryScores: { gut: 1, energy: 1, skin: 3, inflammation: 3 },
    symptomScores: { food_sensitivities: 3, brain_fog: 1, breakouts: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend liposomal quercetin plus zinc for histamine, skin, oxidative-stress, and immune-support patterns that need more than a basic zinc capsule.',
    differentiator: 'It is more targeted to quercetin-zinc synergy than the broader immune formulas in the range.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['immune-defense-protocol', 'pyrrole-perfect'],
    exclusions: [],
    softExclusions: ['autoimmune', 'pregnant_breastfeeding', 'immunosuppressants'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 1 teaspoon daily.',
    resultsTimeline: '1-2 weeks',
    priority: 5,
    maxBundleCount: 1
  },

  'lipo-super-c': {
    name: 'Lipo Super C',
    subtitle: 'Liposomal Vitamin C with Alpha Lipoic Acid — mixed berry',
    price: '$141.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_47_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-super-c-berry-flavour',
    badge: 'Pre-Order',
    format: 'liquid',
    primaryCategories: ['skin', 'energy', 'inflammation'],
    secondaryCategories: [],
    categoryScores: { energy: 3, skin: 4, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 1, aging_skin: 3, breakouts: 1, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend Lipo Super C when a customer needs robust antioxidant and immune support with higher absorption than a standard vitamin C formula.',
    differentiator: 'It offers a more direct liposomal antioxidant hit than whole-food or general support formulas and sits closer to acute immune or recovery support.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: [],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 2 to 3 teaspoons daily.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  'lipo-turmeric': {
    name: 'Lipo Turmeric',
    subtitle: 'Ancient Wisdom, Modern Absorption — curcumin',
    price: '$141.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Untitled_design_49_grande.png',
    shopUrl: 'https://wholistichouse.co/products/lipo-turmeric',
    badge: null,
    format: 'liquid',
    primaryCategories: ['inflammation'],
    secondaryCategories: [],
    categoryScores: { inflammation: 10 },
    symptomScores: { cramps: 1, joint_pain: 3, chronic_inflammation: 3, post_exercise_recovery: 3 },
    whyText: 'A naturopath would recommend Lipo Turmeric for customers needing stronger anti-inflammatory support for joints, recovery, and systemic inflammation.',
    differentiator: 'It delivers turmeric in a higher-bioavailability liposomal base and feels more premium than a standard curcumin capsule.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: ['meriva-curcumin', 'lipo-pea'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding', 'blood_thinners'],
    lifestyleBoosts: { plantBased: true, active: true },
    usageGuidance: 'Take 1 teaspoon daily.',
    resultsTimeline: '1-2 weeks',
    priority: 6,
    maxBundleCount: 1
  },

  // ==========================================
  // POWDERS
  // ==========================================

  'collagen-peptides': {
    name: 'Collagen Peptides',
    subtitle: 'Bioavailable collagen for skin, hair, and nails',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Collagenpeptides_grande.jpg',
    shopUrl: 'https://wholistichouse.co/products/collagen-peptides',
    badge: null,
    format: 'powder',
    primaryCategories: ['skin'],
    secondaryCategories: ['inflammation', 'hair'],
    categoryScores: { skin: 7, hair: 2, inflammation: 4 },
    symptomScores: { aging_skin: 3, hair_thinning: 1, brittle_nails: 3, joint_pain: 3, post_exercise_recovery: 1 },
    whyText: 'A naturopath would recommend collagen peptides to support skin structure, joint integrity, and beauty-from-within foundations.',
    differentiator: 'It is the clearest structural beauty product in the range rather than a hormone, detox, or hair-pigment formula.',
    gender: 'anyone',
    lifeStages: ['aging', 'athletic'],
    conflicts: ['inner-glow-protocol', 'plant-protein-vanilla'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: {},
    usageGuidance: 'Take 1 to 2 scoops daily in water, coffee, or a smoothie.',
    resultsTimeline: '4-6 weeks',
    priority: 6,
    maxBundleCount: 1
  },

  'plant-protein-vanilla': {
    name: 'Plant Protein — Vanilla',
    subtitle: 'Clean Fuel. Complete Nourishment — vegan protein',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/Plant_protein_-_Vanilla_grande.jpg',
    shopUrl: 'https://wholistichouse.co/products/plant-power',
    badge: null,
    format: 'powder',
    primaryCategories: ['skin', 'inflammation', 'energy'],
    secondaryCategories: ['hair'],
    categoryScores: { energy: 2, skin: 3, hair: 2, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, hair_thinning: 1, brittle_nails: 3, post_exercise_recovery: 3 },
    whyText: 'A naturopath would recommend Plant Power when protein intake is too low to support recovery, satiety, and beauty foundations.',
    differentiator: 'It is the clean plant-protein product in the range rather than a therapeutic capsule or liposomal tonic.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['plant-protein-chocolate', 'i-am-complete'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: { plantBased: true, active: true },
    usageGuidance: 'Take 2 scoops (10 g) in 200 mL water or a smoothie.',
    resultsTimeline: '1-2 weeks',
    priority: 4,
    maxBundleCount: 1
  },

  'plant-protein-chocolate': {
    name: 'Plant Protein — Chocolate',
    subtitle: 'Vegan protein blend with collagen and probiotics',
    price: '$71.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/PlantProtein-Choc_grande.jpg',
    shopUrl: 'https://wholistichouse.co/products/plant-power-chocolate',
    badge: null,
    format: 'powder',
    primaryCategories: ['skin', 'inflammation', 'energy'],
    secondaryCategories: ['hair'],
    categoryScores: { energy: 2, skin: 3, hair: 2, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, hair_thinning: 1, brittle_nails: 3, post_exercise_recovery: 3 },
    whyText: 'A naturopath would recommend Plant Protein when low protein intake is undermining recovery, body composition, satiety, or beauty foundations.',
    differentiator: 'It is effectively the same functional role as the vanilla flavour, just a flavour variant.',
    gender: 'anyone',
    lifeStages: ['athletic'],
    conflicts: ['plant-protein-vanilla', 'i-am-complete'],
    exclusions: [],
    softExclusions: ['pregnant_breastfeeding'],
    lifestyleBoosts: { plantBased: true, active: true },
    usageGuidance: 'Take 2 scoops (10 g) in 200 mL water or a smoothie.',
    resultsTimeline: '1-2 weeks',
    priority: 4,
    maxBundleCount: 1
  },

  'metaburn-fibre': {
    name: 'Metaburn Fibre',
    subtitle: 'Feed Your Gut. Fuel Your Glow — prebiotic fiber',
    price: '$66.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/metaburnfibre_grande.jpg',
    shopUrl: 'https://wholistichouse.co/products/metaburn-fibre',
    badge: null,
    format: 'powder',
    primaryCategories: ['gut', 'energy'],
    secondaryCategories: [],
    categoryScores: { gut: 3, energy: 2 },
    symptomScores: { bloating: 3, constipation: 3, food_sensitivities: 1, afternoon_crash: 3 },
    whyText: 'A naturopath would recommend Metaburn Fibre when regularity, satiety, and blood-sugar steadiness all need support at once.',
    differentiator: 'It bridges digestion and metabolism better than a straight bowel product or a straight glucose product alone.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['iron-infusion', 'iodine'],
    exclusions: [],
    softExclusions: ['thyroid', 'diabetes', 'pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take 1 teaspoon (5 g) in water or mix in a smoothie.',
    resultsTimeline: 'days',
    priority: 8,
    maxBundleCount: 1
  },

  // ==========================================
  // SPECIALTY & PROTOCOLS
  // ==========================================

  'iodine': {
    name: 'Iodine',
    subtitle: 'Essential Thyroid & Metabolic Support',
    price: '$39.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/iodine_grande.png',
    shopUrl: 'https://wholistichouse.co/products/iodine',
    badge: null,
    format: 'liquid',
    primaryCategories: ['energy'],
    secondaryCategories: ['hair'],
    categoryScores: { energy: 6, hormones: 1, hair: 2 },
    symptomScores: { constant_fatigue: 3, brain_fog: 3, low_motivation: 3, low_libido: 1, hair_thinning: 1 },
    whyText: 'A naturopath would recommend iodine where thyroid support is likely relevant and low iodine intake could be contributing to low energy, brain fog, or sluggishness.',
    differentiator: 'It is the most direct thyroid-supporting single nutrient in the range and should be used more cautiously than general energy products.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['iron-infusion', 'i-am-complete'],
    exclusions: [],
    softExclusions: ['thyroid', 'autoimmune', 'pregnant_breastfeeding', 'thyroid_meds'],
    lifestyleBoosts: { plantBased: true },
    usageGuidance: 'Take daily as directed on label.',
    resultsTimeline: '1-2 weeks',
    priority: 2,
    maxBundleCount: 1
  },

  'immune-defense-protocol': {
    name: 'Immune Defense Protocol',
    subtitle: 'Curated by Katrina Ellis — comprehensive immune support bundle',
    price: '$299.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/immune_defense_protocol_grande.png',
    shopUrl: 'https://wholistichouse.co/products/immune-defense-protocol',
    badge: 'Pre-Order',
    format: 'protocol',
    primaryCategories: ['energy', 'inflammation', 'stress'],
    secondaryCategories: [],
    categoryScores: { energy: 3, stress: 2, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 1, nutrient_depletion: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend this bundle when someone clearly needs a stronger, practitioner-style immune stack rather than a single daily product.',
    differentiator: 'It is a curated multi-product protocol, not a single supplement, so it should sit later in the customer journey.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['immune-warrior', 'lipo-super-c'],
    exclusions: [],
    softExclusions: ['thyroid', 'diabetes', 'autoimmune', 'pregnant_breastfeeding', 'blood_thinners', 'immunosuppressants'],
    lifestyleBoosts: {},
    usageGuidance: 'Use exactly as directed in the protocol instructions.',
    resultsTimeline: 'days',
    priority: 2,
    maxBundleCount: 1
  },

  'inner-glow-protocol': {
    name: 'Inner Glow Protocol',
    subtitle: 'Created by Katrina Ellis — radiance from within',
    price: '$299.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/inner_glow_protocol_grande.png',
    shopUrl: 'https://wholistichouse.co/products/inner-glow-protocol',
    badge: null,
    format: 'protocol',
    primaryCategories: ['skin', 'hair'],
    secondaryCategories: [],
    categoryScores: { skin: 7, hair: 7 },
    symptomScores: { aging_skin: 3, hair_thinning: 3, hair_greying: 1, brittle_nails: 3 },
    whyText: 'A naturopath would recommend this bundle when the goal is a more complete beauty protocol rather than choosing just one skin, hair, or nails product.',
    differentiator: 'It is a curated beauty stack rather than a single formula, so it belongs later in the buying journey.',
    gender: 'anyone',
    lifeStages: ['aging'],
    conflicts: ['hair-juice', 'ageless-beauty'],
    exclusions: [],
    softExclusions: ['thyroid', 'pregnant_breastfeeding', 'blood_thinners', 'thyroid_meds'],
    lifestyleBoosts: {},
    usageGuidance: 'Use exactly as directed in the protocol instructions.',
    resultsTimeline: '4-6 weeks',
    priority: 2,
    maxBundleCount: 1
  },

  'respiratory-renewal-protocol': {
    name: 'Respiratory Renewal Protocol',
    subtitle: 'Created by Katrina Ellis — breathe easy, renew deeply',
    price: '$299.99 AUD',
    imageUrl: 'https://wholistichouse.co/cdn/shop/files/respiratory_renewal_protocol_grande.png',
    shopUrl: 'https://wholistichouse.co/products/respiratory-renewal-protocol',
    badge: null,
    format: 'protocol',
    primaryCategories: ['energy', 'inflammation', 'sleep'],
    secondaryCategories: [],
    categoryScores: { energy: 3, sleep: 2, inflammation: 3 },
    symptomScores: { constant_fatigue: 3, brain_fog: 1, unrefreshed: 3, chronic_inflammation: 3 },
    whyText: 'A naturopath would recommend this bundle when a customer needs a stronger practitioner-led respiratory support stack rather than one single product.',
    differentiator: 'It is a protocol bundle, not a standalone symptom-first supplement.',
    gender: 'anyone',
    lifeStages: [],
    conflicts: ['immune-warrior', 'lipo-super-c'],
    exclusions: [],
    softExclusions: ['thyroid', 'diabetes', 'autoimmune', 'pregnant_breastfeeding', 'blood_thinners', 'immunosuppressants'],
    lifestyleBoosts: {},
    usageGuidance: 'Use exactly as directed in the protocol instructions.',
    resultsTimeline: 'days',
    priority: 1,
    maxBundleCount: 1
  },
};
